import React from 'react';
import styled from 'styled-components';

import { Like, Play } from '../../../assets/Card';
import { Title } from '../../Typhography';
import { CardProps } from '../../../types/components/Card';

const CardContainer = styled.div`
  width: 100px;
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin: 30px;
`;

const CardImage = styled.img`
  width: 136px;
  height: 136px;
  border-radius: 15px;
`;

const CardFooter = styled.div`
  display: flex;
  flex-direction: row;
  height: 15px;
`;

const CardTitle = styled(Title)`
  font-size: 16px;
  padding: 5px;
`;

const Likes = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 5px;
`;

const Plays = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 5px;
`;

const CardText = styled.p`
  font-size: 13px;
  margin: 0px 5px;
  color: ${(props) => props.theme.colors.gray};
`;

export default function Card(props: CardProps) {
  return (
    <CardContainer>
      <CardImage src={props.imageUrl} alt={props.title} />
      <CardTitle>{props.title}</CardTitle>
      <CardFooter>
        <Likes>
          <img src={Like} alt="Likes" />
          <CardText>{props.likes}</CardText>
        </Likes>
        <Plays>
          <img src={Play} alt="Play" />
          <CardText>{props.play}</CardText>
        </Plays>
      </CardFooter>
    </CardContainer>
  );
}
